module.exports = __webpack_public_path__ + "static/media/fo.3f2be9cc.svg";